import { Component } from '@angular/core';
import {UpgradeModule} from "@angular/upgrade/static";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';


  constructor(private upgrade: UpgradeModule) {
    this.ngDoBootstrap();
  }
  ngDoBootstrap() {
    this.upgrade.bootstrap(document.body, ['kompoApp']);
  }
}



// WEBPACK FOOTER //
// ./src/components/app/app.component.ts